import { ActionsDropdown } from '@molecules';
import { Controller } from '@organisms';
import { Col, Row, Tag } from 'antd';
import { FieldArrayWithId, useFormContext } from 'react-hook-form';

import { TenantFormData } from 'src/features/tenants/types/tenantForm.types';

export interface DomainsListProps {
  domainField: 'add' | 'edit';
  fields: FieldArrayWithId<
    TenantFormData,
    'domains.add' | 'domains.edit',
    '_id'
  >[];
  onMarkAsPrimary: (index: number, id?: number) => void;
  onUnMarkAsPrimary: (index: number, id?: number) => void;
  onDelete: (index: number, id?: number) => void;
}
export const DomainsList = ({
  domainField,
  fields,
  onMarkAsPrimary,
  onUnMarkAsPrimary,
  onDelete,
}: DomainsListProps) => {
  const name: 'domains.add' | 'domains.edit' = `domains.${domainField}`;
  const { control, watch } = useFormContext<TenantFormData>();

  const deletedFields = watch('domains.delete');
  return fields.map((field, index) => (
    <Row
      key={field._id}
      style={{
        alignItems: 'center',
        padding: 16,
        border: '1px solid #424242',
        borderRadius: 2,
        gap: 8,
        marginBlockEnd: 16,
        display: `${
          field.id && deletedFields?.includes(field.id) ? 'none' : 'flex'
        }`,
      }}
    >
      <Col flex='auto' style={{ marginBottom: -8 }}>
        <Controller
          size='large'
          suffix={
            field.isPrimary ? (
              <Tag style={{ marginRight: 0 }}>Domínio principal</Tag>
            ) : undefined
          }
          placeholder='https://'
          name={`${name}.${index}.domain`}
          control={control}
        />
      </Col>
      <Col>
        <ActionsDropdown
          customOptions={[
            {
              icon: <></>,
              label: field.isPrimary
                ? 'Desmarcar como principal'
                : 'Marcar como principal',
              onClick: () => {
                field.isPrimary
                  ? onUnMarkAsPrimary(index, fields[index].id)
                  : onMarkAsPrimary(index, fields[index].id);
              },
            },
            {
              icon: <></>,
              label: 'Excluir',
              onClick: () => onDelete(index, fields[index].id),
            },
          ]}
        />
      </Col>
    </Row>
  ));
};
